var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body warp" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "buju" }, [
        _vm.noImg
          ? _c("div", { staticClass: "tuijian" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.noImg
                ? _c(
                    "div",
                    { staticClass: "lunbo" },
                    [
                      _c(
                        "swiper",
                        {
                          staticClass: "swiper",
                          attrs: { options: _vm.swiperOption }
                        },
                        [
                          _vm._l(_vm.imgData, function(item) {
                            return _c(
                              "swiper-slide",
                              { key: item, staticClass: "swiper-slide" },
                              [
                                _c("div", { staticClass: "swiper-content" }, [
                                  _c("img", {
                                    staticStyle: {
                                      width: "155px",
                                      height: "155px"
                                    },
                                    attrs: { src: item.image, alt: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toProductDetail(item)
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "swiper-pagination",
                            attrs: { slot: "pagination" },
                            slot: "pagination"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "swiper-button-prev",
                              attrs: { slot: "button-prev" },
                              slot: "button-prev"
                            },
                            [_c("i", { staticClass: "el-icon-arrow-left" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "swiper-button-next",
                              attrs: { slot: "button-next" },
                              slot: "button-next"
                            },
                            [_c("i", { staticClass: "el-icon-arrow-right" })]
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "box2 flex-col" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "productList" },
            [
              _c("ProductList", { attrs: { productList: _vm.productList } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "block",
                    "padding-bottom": "20px",
                    "text-align": "center"
                  }
                },
                [
                  _vm.productList.length > 0
                    ? _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.page,
                          "page-size": _vm.pageSize,
                          background: "",
                          layout: "prev, pager, next",
                          total: _vm.total
                        },
                        on: { "current-change": _vm.handleCurrentChange }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pictBox" }, [
      _c("img", {
        staticClass: "pict",
        attrs: { src: require("../../assets/images/zhutuikuan.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bd3 flex-row" }, [
      _c("img", {
        staticClass: "label3",
        attrs: {
          referrerpolicy: "no-referrer",
          src:
            "https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng13a746e8307d734f4df8ab7961335667735c3aa0dca9036d8bdd802c1b29c1ae"
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "info5" }, [_vm._v("最新商品")]),
      _vm._v(" "),
      _c("img", {
        staticClass: "label4",
        attrs: {
          referrerpolicy: "no-referrer",
          src:
            "https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng6e22c3954334c26456733d5ad5a4c16913ccac1713429f9adfe43e05929658be"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-ea745822", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-ea745822","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/shopHome.vue
// module id = null
// module chunks = 